<template lang="pug">
span#reports
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
      style='float: right;'
      @click='filterDialog = true')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-filter-variant
        span(style='color: black')
          | {{$t('chatHistory.filter')}}
  div
    DataProvider(:key="componentKey" :endpoint='mountUrlAndParams("notificationsReport").url' :filter='filter' ref='dataProvider')
      div(slot-scope='{ data: response, error, loading }')
        DataTable(
          customIcon='lista-campanhas'
          :data='response && response.data'
          ref='dataTable'
          :title="$t('campaign.campaignFiredList')"
          :customTotal='(response && response.total) || 0'
          @pagination='handlePagination'
          :currentSort.sync='filter.orderBy',
          :currentSortOrder.sync='filter.order',
          :selectable='false'
          :loading='loading'
          customHeader
          :customTableStyle='customTableStyle'
          :endpoint='mountUrlAndParams("notificationsReport").url'
          :filter='filter'
          :labels='labels'
          :formatLabelFunction='formatLabels'
          :fileName="$t('campaign.campaignListFileName')"
          orientationPDF="landscape"
          :createHeader='createHeaderPDF')
          template(slot='footer' slot-scope='{ pagination }')
            v-row(style='justify-content: flex-end;')
              v-col(cols='auto')
                md-field
                  label(for='pages') {{ $t('assistantsList.perPage') }}
                  md-select(v-model='pagination.perPage' name='pages' )
                    md-option(
                      v-for='item in pagination.perPageOptions',
                      :key='item',
                      :label='item',
                      :value='item')
                      | {{ item }}
          //- waiting for backend
          //- template(slot="custom-filter")
          //-   v-text-field(style='float: right; margin-right: 19px; width: 30%;margin-top: 20px; margin-left: 10px;'
          //-     :placeholder="$t('table.enterWordOrDataForTheSearch')"
          //-     hide-details
          //-     filled
          //-     dense
          //-     :value='search'
          //-     @input='updateSearch'
          //-   )
          template(slot='cells' slot-scope='{ item }')
            md-table-cell(:md-label='labels[0]') {{ formatLabels(item, 0) }}
            md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
            md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
            md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
            md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
            md-table-cell(:md-label='labels[5]') {{ formatLabels(item, 5) }}
            md-table-cell(:md-label='labels[6]') {{ formatLabels(item, 6) }}
            md-table-cell(:md-label='labels[7]') {{ formatLabels(item, 7) }}
            md-table-cell(:md-label='labels[8]') {{ formatLabels(item, 8) }}
            md-table-cell(:md-label='labels[9]') {{ formatLabels(item, 9) }}
            md-table-cell(:md-label='labels[10]') {{ formatLabels(item, 10) }}
    GlobalDialog(
      v-model='filterDialog'
      max-width='700px'
      scrollable
      :headerTitle="$t('campaign.filter')"
      showMButton
      mButtonTextColor='#FE544F'
      mButtonColor='#FE544F'
      mButtonIsOutlined
      :mButtonTitle="$t('chatHistory.reset')"
      @clickMButton='resetFilter()'
      showRButton
      :rButtonTitle="$t('chatHistory.apply')"
      @clickRButton='saveFilter()')
      template(v-slot:content)
        v-col
          h5.descTitle {{ $t('campaign.campaignData') }}
          div(style='display: flex; flex-direction: row;')
            v-select(
              style='margin-right: 16px; height: 50px; margin-bottom: 15px;'
              filled
              dense
              hide-details
              v-model="selectedCampaign"
              @change="handleFilterOptions('campaignName', $event)"
              :label="$t('campaign.campaignName')"
              item-text="text"
              item-value="value"
              :items="campaignList"
              multiple
            )
            v-sapace
            v-select(
              style='margin-bottom: 15px; height: 50px;'
              filled
              hide-details
              dense
              v-model="selectedChanels"
              @change="handleFilterOptions('channel', $event)"
              :label="$t('commonWords.channel')"
              item-text="text"
              item-value="value"
              :items="channelList"
              multiple
            )
          h5.descTitle {{ $t('campaign.sendDataSender') }}
          v-text-field(
            v-model="selectedSender"
            style='margin-bottom: 15px; height: 50px;'
            :placeholder="$t('campaign.sender')"
            filled
            :value='sender'
            @input='updateSearchItem($event, "sender")'
          )
          h5.descTitle {{ $t('campaign.sendDataReceiver') }}
          div(style='display: flex; flex-direction: row;')
            v-text-field(
              v-model="selectedUsername"
              style='margin-right: 16px; margin-bottom: 15px;'
              :placeholder="$t('campaign.receiverName')"
              hide-details
              filled
              :value='username'
              @input='updateSearchItem($event, "username")'
            )
            v-text-field(
              v-model="selectedContact"
              style='margin-bottom: 15px;'
              :placeholder="$t('campaign.receiver')"
              hide-details
              filled
              :value='contact'
              @input='updateSearchItem($event, "contact")'
            )
          h5.descTitle {{ $t('campaign.sendInformation') }}
          v-select(
            style='width: 48%; height: 50px; '
            filled
            dense
            v-model="selectedStatus"
            @change="handleFilterOptions('status', $event)"
            :label="$t('usersList.status')"
            item-text="text"
            item-value="name"
            :items="statusList"
            multiple
          )
</template>
<script>
import DataProvider from '@/components/DataProvider'
import { mapFields } from 'vuex-map-fields'
import moment from 'moment'
// import debounce from 'lodash/debounce'
import CardNoData from '@/components/CardNoData'
import DataTable from '@/components/DataTable'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { selectedLocale } from '@/plugins/i18n'

const initialChannels = [
  { text: 'Instagram', name: 'instagram', isActive: false, status: '' },
  { text: 'Push', name: 'push', isActive: false, status: '' },
  { text: 'SMS', name: 'sms', isActive: false, status: '' },
  { text: 'Teams', name: 'teams', isActive: false, status: '' },
  { text: 'WhatsApp', name: 'whatsapp', isActive: false, status: '' }
]

export default {
  data () {
    return {
      customTableStyle: {
        headStyles: {
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },
        bodyStyles: { minCellWidth: 20 }
      },
      search: '',
      sender: '',
      username: '',
      contact: '',
      channelList: [ ...initialChannels ],
      statusList: [
        { text: this.$t('campaign.sent'), name: 'sent', isActive: false, status: '' },
        { text: this.$t('commonWords.error'), name: 'failed', isActive: false, status: '' },
        { text: this.$t('campaign.read'), name: 'read', isActive: false, status: '' },
        { text: this.$t('campaign.delivered'), name: 'delivered', isActive: false, status: '' }
      ],
      campaignList: [],
      selectedCampaign: null,
      selectedChanels: null,
      selectedStatus: null,
      selectedSender: null,
      selectedContact: null,
      selectedUsername: null,
      filterDialog: false,
      componentKey: 0,
      labels: [
        this.$t('campaign.title'),
        this.$t('campaign.triggeredAt'),
        this.$t('campaign.template'),
        this.$t('campaign.campaignChannel'),
        this.$t('campaign.sender'),
        this.$t('campaign.receiver'),
        this.$t('campaign.receiverName'),
        this.$t('usersList.status'),
        this.$t('campaign.return'),
        this.$t('campaign.reading'),
        this.$t('campaign.info')
      ],
      allFilter: null,
      filter: {
        order: 'desc',
        page: 0,
        perPage: 5
      }
    }
  },
  mixins: [isTenantMixin],
  created () {
    this.filter = {
      ...this.filter,
      from: this.dateInterval.timestamp1,
      to: this.dateInterval.timestamp2,
      select: this.dateInterval?.select?.value
    }
    this.requestCampaignNames()
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  components: {
    GlobalDialog,
    DataProvider,
    CardNoData,
    DataTable
  },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    updateSearchItem (value, key) {
      this.allFilter = { ...this.allFilter, [key]: value }
    },
    // waiting for backend
    // updateSearch: debounce(function (value) {
    //   this.filter.search = value
    //   this.$refs.dataProvider.load()
    // }, 400),
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    requestCampaignNames () {
      let initialCampaign = []
      const { url, filter } = this.mountUrlAndParams('names')
      try {
        this.$axios.get(`${url}`, {
          params: { ...this.filter, time_zone: '-03:00', from: filter.from, to: filter.to }
        }).then(response => {
          if (response && response.status === 200) {
            if (response.data.length) {
              for (let i = 0; i < response.data.length; i++) {
                initialCampaign.push({ text: response.data[i], name: '', isActive: false, status: '' })
              }
              this.campaignList = initialCampaign
            }
          }
        })
      } catch (error) {
      }
    },
    handleFilterOptions (key, event) {
      let items = key === 'channel' ? event.toString().toLowerCase() : event.toString()
      this.allFilter = { ...this.allFilter, [key]: items }
    },
    forceRerender () {
      this.componentKey += 1
    },
    resetFilter () {
      this.selectedCampaign = null
      this.selectedChanels = null
      this.selectedStatus = null
      this.selectedSender = null
      this.selectedUsername = null
      this.selectedContact = null
      this.saveFilter(true)
    },
    saveFilter (update = false) {
      if (update) {
        this.$delete(this.filter, 'channel')
        this.$delete(this.filter, 'campaignName')
        this.$delete(this.filter, 'sender')
        this.$delete(this.filter, 'username')
        this.$delete(this.filter, 'contact')
        this.$delete(this.filter, 'status')
      }
      if (this.allFilter) {
        const filters = { ...this.filter, ...this.allFilter }
        this.filter = filters
        this.allFilter = null
      }
      this.filterDialog = false
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
      this.requestCampaignNames()
    },
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      const select = this.dateInterval?.select?.value
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/campaign/${endpoint}`,
        filter: { to, from, select: select }
      }
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    formatErrorDetails (errorCode, erroMessage) {
      if (errorCode && erroMessage) {
        return `Error ${errorCode} - ${erroMessage}`
      } else if (errorCode && !erroMessage) {
        return `Error ${errorCode}`
      } else if (erroMessage && !errorCode) {
        return erroMessage
      }
      return '-'
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item.campaignName
        case 1:
          return this.formatDate(item.createdAt)
        case 2:
          return item.templateName
        case 3:
          return item.channel
        case 4:
          return item.channel === 'whatsapp' ? item.from : item.botId || ''
        case 5:
          return item.contact
        case 6:
          return item.username
        case 7:
          return this.$t(`campaign.${item.status}`)
        case 8:
          return item.httpStatus
        case 9:
          return item.readAt ? this.formatDate(item.readAt) : '-'
        case 10:
          return this.formatErrorDetails(item.errorCode, item.errorDetails)
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.campaignFiredList'))
      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('chatTable.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  }
}
</script>
<style lang="scss">
.boxRow {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
.descTitle {
  margin-bottom: 5px;
  font-weight: 400;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}
</style>
